import React from 'react';
import { useTranslate } from 'react-admin';

import { GridCard } from '../../../components';
import { TimeClockTrackerInput } from './TimeClockTrackerInput';

const TimeClockTrackerCard = (props) => {
  const translate = useTranslate();

  return (
    <GridCard
      {...props}
      title={translate('resources.account.card_title.time_clock_tracker')}
    >
      <TimeClockTrackerInput editMode={false} />
    </GridCard>
  );
};

export default TimeClockTrackerCard;
